import React from "react";
import classNames from "classnames";
import { useIntl } from "react-intl";

import { ReactComponent as SearchIcon } from "static/icons/search-black.svg";
import { useFreeText } from "./useCollection";
import styles from "./SearchBar.module.scss";

interface Props {
    handleClear: () => void;
    className?: string;
}

const InputClearButton = ({ handleClear, className }: Props) => {
    return (
        <button
            type="button"
            className={classNames(styles["input-clear-btn"], className)}
            aria-label="Clear"
            onClick={handleClear}
        >
            <span>&times;</span>
        </button>
    );
};

interface InputProps {
    value: string;
    onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
    handleClear: () => void;
}

const Input = ({ value, onChange, handleClear }: InputProps) => {
    const intl = useIntl();
    return (
        <div className={styles["input-container"]}>
            <input type="text" className={styles["input"]} value={value} onChange={onChange} />
            <span className={styles["input-placeholder"]}>
                {intl.formatMessage({ id: "collection_page.search_bar.placeholder" })}{" "}
                <em className={styles["input-placeholder__onboarding"]}>
                    {intl.formatMessage({
                        id: "collection_page.search_bar.placeholder.onboarding",
                    })}
                </em>
            </span>
            <InputClearButton handleClear={handleClear} className={styles["input__clear-btn"]} />
        </div>
    );
};

const SearchBar = () => {
    const [value, onFreeTextChange] = useFreeText();
    function onChange(e: React.ChangeEvent<HTMLInputElement>) {
        onFreeTextChange(e.target.value);
    }
    function handleClear() {
        onFreeTextChange("");
    }
    return (
        <div className={styles["search-bar"]}>
            <div className={styles["search-bar__content"]}>
                <SearchIcon className={styles["search-bar__search-icon"]} />
                <Input handleClear={handleClear} value={value} onChange={onChange} />
            </div>
        </div>
    );
};

export default SearchBar;
